class AddUserEmployerType {
  construction() {
    this.AddEmployer = '';
    this.AddLocation = '';
    this.AddGroups = '';
  }

  getAddEmployer() {
    return this.AddEmployer;
  }

  setAddEmployer(AddEmployer) {
    this.AddEmployer = AddEmployer;
  }

  getAddLocation() {
    return this.AddLocation;
  }

  setAddLocation(AddLocation) {
    this.AddLocation = AddLocation;
  }

  getAddGroups() {
    return this.AddGroups;
  }

  setAddGroups(AddGroups) {
    this.AddGroups = AddGroups;
  }

  resetAddUersInsurer() {
    this.AddEmployer = '';
    this.AddLocation = '';
    this.AddGroups = ';';
  }
}
export default new AddUserEmployerType();
